import Swiper from 'swiper';
// import AOS from 'aos';

import { Navigation, Pagination } from 'swiper'
Swiper.use([Navigation, Pagination])

//mobile menu toggle
document.getElementById('hamburgerToggle').onclick = () => {
    document.getElementById('hamburger').classList.toggle('is-active'),
    document.getElementById('mobileMenu').classList.toggle('mobile__menu--show'),
    document.getElementById('site-header').classList.toggle('header-mobile')
  }


//scroll to top button function 
function scrollToTop() {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }
  document.getElementById("scrollToTopBtn").addEventListener("click", scrollToTop)
  document.getElementById("scrollToTopBtnMobile").addEventListener("click", scrollToTop)


  
new Swiper('#featured-products-carousel', {
  slidesPerView: 1,
  autoplay: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  breakpoints: {
    768: {
      enabled: false,
    },
  },
})

//search toggle

document.getElementById('search-toggle').onclick = () => {
  document.getElementById('search-container').classList.toggle('search__container-open')
}

document.getElementById('search-close').onclick = () => {
  document.getElementById('search-container').classList.toggle('search__container-open')
}
